import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { buildImageUrl } from '../../services/apiConfig';

const PopupModal = ({ popup, show, onClose, onMarkViewed, totalPopups, currentIndex }) => {
    const handleClose = async () => {
        try {
            if (onMarkViewed && popup?._id) {
                await onMarkViewed(popup._id);
            }
            onClose();
        } catch (error) {
            console.error('Error marking popup as viewed:', error);
            onClose();
        }
    };

    // Simple HTML parser function (basic implementation)
    const parseHTML = (htmlString) => {
        if (!htmlString) return null;
        // For basic HTML, we can use dangerouslySetInnerHTML
        // For production, consider using html-react-parser library
        return { __html: htmlString };
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {popup?.title || 'Notification'}
                    {totalPopups > 1 && (
                        <small className="text-muted ms-2">
                            ({currentIndex} of {totalPopups})
                        </small>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {popup?.image && (
                    <div className="popup-image mb-3">
                        <img 
                            src={buildImageUrl(popup.image)} 
                            alt={popup.title || 'Popup image'}
                            className="img-fluid"
                            onError={(e) => {
                                console.error('Failed to load popup image:', e.target.src);
                                e.target.style.display = 'none';
                            }}
                        />
                    </div>
                )}
                <div className="popup-content">
                    {popup?.content && (
                        <div dangerouslySetInnerHTML={parseHTML(popup.content)} />
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                    {currentIndex === totalPopups ? 'Got it!' : 'Next'}
                </Button>
            </Modal.Footer>

            <style>{`
                .popup-image {
                    text-align: center;
                }
                .popup-image img {
                    max-width: 100%;
                    border-radius: 8px;
                }
                .popup-content {
                    font-size: 16px;
                    line-height: 1.5;
                }
                .popup-content p {
                    margin-bottom: 1rem;
                }
            `}</style>
        </Modal>
    );
};

export default PopupModal;
